<template>
  <!--div>
        <router-link to="/dn/v2"><h2>Wareneingang</h2></router-link>
    </div-->
  <div class="container-fluid" v-if="vendor">
    <div class="row">
      <div class="col-8 offset-2">
        <!--Breadcrumb-->
        <nav style="font-size: 35px" aria-label="breadcrumb">
          <ol class="breadcrumb py-0 pt-3 container bg-light">
            <li class="breadcrumb-item pl-2 pr-2">
              <router-link to="/dn/v2">Wareneingang</router-link>
            </li>
            <li
              v-if="$route.params.vendorId > 0"
              class="breadcrumb-item pl-2 pr-2"
            >
              <router-link :to="'/dn/v2/vendor/' + vendor.id">{{
                vendor.name
              }}</router-link>
            </li>
            <li v-else class="breadcrumb-item pl-2 pr-2">
              <router-link :to="'/dn/v2/vendor/-1'">Alle Händler</router-link>
            </li>
            <li
              v-if="$route.params.deliveryNoteId > 0"
              class="breadcrumb-item pl-2 pr-2"
              aria-current="page"
            >
              LS {{ deliveryNote.number }}
            </li>
            <li
              v-else-if="$route.params.deliveryNoteId == -1"
              class="breadcrumb-item pl-2 pr-2"
              aria-current="page"
            >
              Gesamtübersicht
            </li>
            <li
              v-else-if="$route.params.deliveryNoteId == -2"
              class="breadcrumb-item pl-2 pr-2"
              aria-current="page"
            >
              Gesamtübersicht freigegeben
            </li>
            <li
              v-else-if="$route.params.deliveryNoteId == -3"
              class="breadcrumb-item pl-2 pr-2"
              aria-current="page"
            >
              Gesamtübersicht 3 Monate
            </li>
            <li v-else class="breadcrumb-item pl-2 pr-2" aria-current="page">
              ERROR
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="row">
      <div class="col-2">
        <!-- Linkes Filter Fenster -->
        <!-- Filter Fenster-->
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Filter</h5>
            <div class="input-group rounded pb-3">
              <input
                type="search"
                class="form-control rounded"
                placeholder="z.B EAN"
                aria-label="Search"
                aria-describedby="search-addon"
                v-model="filter"
                ref="search"
              />
            </div>
            <!--Checkbox Filter-->
            <b-form-checkbox
              v-model="openOnly"
              :value="true"
              :unchecked-value="false"
              :disabled="processedOnly"
            >
              Nur offene
            </b-form-checkbox>
            <b-form-checkbox
              v-model="processedOnly"
              :value="true"
              :unchecked-value="false"
              :disabled="openOnly"
            >
              Nur abgeschlossene
            </b-form-checkbox>
            <h5 class="card-title pt-3">Aktionen</h5>
            <!--Buttons-->

            <button
              @click="setProcessingReasonForSelection"
              class="btn btn-primary mb-2 btn-block"
              :disabled="selectedPositions.length == 0"
            >
              {{ selectedPositions.length }} x Abschließen
            </button>
            <button
              @click="showClaimModalFor(selectedPositions)"
              class="btn btn-secondary mt-2 btn-block"
              :disabled="selectedPositions.length == 0"
            >
              {{ selectedPositions.length }} x Reklamieren
            </button>
            <button
              @click="checkForStates(selectedPositions)"
              class="btn btn-secondary mt-2 btn-block"
              :disabled="selectedPositions.length == 0"
            >
              {{ selectedPositions.length }} x Einlagern
              <b-spinner
                v-if="stockingModal.busy"
                small
                variant="light"
                label="spinning"
              ></b-spinner>
            </button>

            <div v-if="this.$route.params.deliveryNoteId > 0">
              <button
                @click="showCompleteAllModal = true"
                class="btn btn-danger mt-4 btn-block"
              >
                Lieferschein abschließen
              </button>
              <b-modal
                centered
                id="add-tracking-modal"
                title="Lieferschein abschließen"
                no-close-on-backdrop
                v-model="showCompleteAllModal"
                @ok="finalizeDeliveryNote"
              >
                <h5 class="mb-4 mt-4 text-center">
                  Sind sie sicher, dass sie den Lieferschein und die übrigen
                  Positionen abschließen möchten?
                </h5>
                <template #modal-footer="{ ok, cancel }">
                  <b-button
                    type="button"
                    class="btn-secondary"
                    @click="cancel()"
                    >Abbrechen</b-button
                  >
                  <b-button type="button" class="btn-danger" @click="ok()"
                    >Abschließen</b-button
                  >
                </template>
              </b-modal>
            </div>
            <hr />
            <b-button
              variant="secondary"
              class="btn btn-primary btn-block"
              @click="exportToXSLX(filteredPositions)"
            >
              <i class="bi bi-file-earmark-spreadsheet"></i> Export to Excel
            </b-button>
						<b-button
								variant="secondary"
								class="btn btn-primary btn-block"
								@click="showQRCodeModal = true"
						>
							Fotos machen
						</b-button>
						<b-modal v-model="showQRCodeModal" hide-footer hide-header centered size="sm">
							<div class="d-flex flex-column align-items-center">
								<div>
									<qrcode-vue
											:value="qrCodeString"
											:size="295"
											level="H"
											render-as="svg"
											margin="2"
									/>
									<div class="text-center"> {{qrCodeString}}</div>
								</div>
							</div>

						</b-modal>
						<b-button
								variant="secondary"
								class="btn btn-primary btn-block"
								:disabled="!hasReturnImages"
								@click="downloadReturnImages()"
						>
							Fotos herunterladen
						</b-button>

          </div>
        </div>
      </div>

      <!-- Wareneingang Seite1 Lieferanten-->
      <div class="col-8">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between">
              <b-form-group>
                <b-form-radio-group
                  id="btn-radios-amount"
                  v-model="perPage"
                  :options="amountOptions"
                  name="radios-btn-default"
                  button-variant="outline-primary"
                  size="lg"
                  buttons
                ></b-form-radio-group>
              </b-form-group>

              <b-form-group v-if="this.$route.params.deliveryNoteId > 0">
                <h2>
                  <b-badge
                    :variant="
                      deliveryNote.packageArrived ? 'success' : 'danger'
                    "
                    >{{
                      deliveryNote.packageArrived ? "Freigegeben" : "Gesperrt"
                    }}</b-badge
                  >
                  <a class="clickable" @click="switchPackageArrived">
                    <i class="bi bi-arrow-left-right"></i
                  ></a>
                </h2>
              </b-form-group>

														<span>
															LS-Datum: <br>
															{{ deliveryNote.date ? moment(deliveryNote.date).format("DD.MM.YYYY") : "-" }}
														</span>

                            <div>
                                Positionen: {{ positions.length }}, davon offen: {{ openPositions.length  }}<br>
                                Artikel: {{ articleCount }}, davon offen: {{ openArticleCount }}
                            </div>

              <b-pagination
                v-model="currentPage"
                :total-rows="filteredPositions.length"
                :per-page="perPage"
              ></b-pagination>
            </div>

            <b-table
              striped
              hover
              :items="filteredPositions"
              :fields="filteredfields"
              :current-page="currentPage"
              :per-page="perPage"
              sort-by="deliverynote.date"
              :sort-desc="true"
              :tbody-tr-class="rowClassSelector"
              class="mikasmallz mb-0"
            >
              <template #head(_isSelected)>
                <b-form-checkbox
                  :checked="allSelected"
                  :value="true"
                  :unchecked-value="false"
                  @change="processCheckAllSelections"
                >
                </b-form-checkbox>
              </template>

              <template #cell(_isSelected)="data">
                <b-form-checkbox
                  v-model="data.item._isSelected"
                  :value="true"
                  :unchecked-value="false"
                >
                </b-form-checkbox>
              </template>
              <template #cell(barcode)="data">
								<copy-to-clipboard-component alertDisplayLength='1' alertShowCopiedText="true">
									{{ data.item.barcode }}
								</copy-to-clipboard-component>
              </template>

							<template #cell(deliverynote.number)="data">
								<router-link :to="'/dn/v2/vendor/' + data.item.deliverynote.vendorId + '/dn/' + data.item.deliverynote.id">{{
										data.item.deliverynote.number ? data.item.deliverynote.number  : "Unknown"
									}}</router-link>
							</template>

              <template #cell(actions)="data">
                <div v-if="!isProcessed(data.item)">
                  <a
                    class="clickable"
                    @click="setProcessingReason(data.item)"
                    title="komplette Menge abschließen"
                    ><i class="bi bi-check-square"></i
                  ></a>
                  <a
                    class="clickable"
                    @click="showClaimModalFor([data.item])"
                    title="reklamieren"
                    ><i class="bi bi-bootstrap-reboot"></i
                  ></a>
                  <input
                    class="smallinput"
                    v-model="data.item._quantityToProcess"
                  />
                  <a
                    class="clickable"
                    @click="setProcessingReasonQuantity(data.item)"
                    title="bestimmte Menge abschließen"
                    ><i class="bi bi-check-square"></i
                  ></a>
                  <a
                    class="clickable"
                    @click="checkForStates(data.item)"
                    title="bestimmte Menge einlagern"
                    ><i class="bi bi-upc-scan"></i
                  ></a>
                </div>
                <div v-else>
                  <input
                    class="smallinput"
                    v-model="data.item._quantityToProcess"
                  />
                  <a
                    class="clickable"
                    @click="revertProcessedPostion(data.item)"
                    title="Position rückgangig machen"
                    ><i class="bi bi-check-square"></i
                  ></a>
                </div>
              </template>

              <template #cell(quantityProcessed)="data">
                {{ getSumProcessedQuantity(data.item) }}
              </template>

                            <template #cell(orderState)="row">
                                <span v-if="row.item.deliverynotepositionprocesss.length == 0"> 
                                    {{ (row.item.orderlog == undefined || row.item.orderlog.customerorder == undefined) ? "Kein Orderlog" : labelOrderState(row.item.orderlog.customerorder.orderState) }}
                                </span>
                                <span v-else>
                                    <span v-for="process in row.item.deliverynotepositionprocesss" v-bind:key="process.id" class="p-l">
                                        {{ process.quantityProcessed }} x {{ process.user ? process.user.shortname : user.shortname}} {{ process.processedAt ? ' - ' + moment(process.processedAt).format('DD.MM.YYYY HH:mm:ss') : ''}} <!---->
                                    </span>
                                </span>
                            </template>

                        </b-table>
                    </div>
                </div>
            </div>
            <div class="col-2">
                <div class="card" v-if="deliveryNote && user && users">
                    <div class="card-body">
                        <h5 class="card-title text-center">Kommentare</h5>
                        <dn-comments :deliveryNoteId='$route.params.deliveryNoteId'
                            :passedDeliveryNoteComments='deliveryNote.deliverynotecomments' :users='users'
                            :user_id='user.id' />
                    </div>
                </div>
            </div>
        </div>
        <b-modal class="stockingModal" v-model="stockingModal.show" @hide="resetStockingModal()">
                <template #modal-header>
                    <h2 class="text-center">{{stockingModal.title}}</h2>
                </template>
                <!------------------blocked word wide - Multiple Positions------------------------->
                <div v-if="stockingModal.blockedPositions?.length > 0 && stockingModal.positions?.length >= 1" >
                    Folgende Postionen sind weltweit gesperrt:<br>
                    <div v-for="position in stockingModal.blockedPositions" :key="position.reference">
                        Barcode: {{position.barcode}} - Referenz: {{position.reference}}<br>
                    </div>               
                </div>
                <div v-if="stockingModal.blockedPositions?.length > 0 && stockingModal.positionsWithOrderStateNew?.length > 0">
                    <hr>
                </div>
                <!--------------"New" OrderState for a Customer Order - Multiple Positions---------->
                <div v-if="stockingModal.positionsWithOrderStateNew?.length > 0 && stockingModal.positions.length >= 1" >
                    Für diese Positionen wurde mind. eine Bestellung mit dem Status "Neu" gefunden:<br>
                    <div v-for="position in stockingModal.positionsWithOrderStateNew" :key="position.reference">
                        Barcode: {{position.barcode}}<br>
                    </div>                
                </div>
                <!-----------------"New" OrderState for a Customer Order - Single Position----------->
                <div v-if="stockingModal.positionsWithOrderStateNew?.length > 0 && stockingModal.position" >
                    Für diese Position wurde mind. eine Bestellung mit dem Status "Neu" gefunden.
                    Möchten sie trotzdem einlagern?
                </div>
                <!-------------------When conflicts Multiple Positons--------------------------------------------->
                <div v-if="stockingModal.blockedPositions.length > 0 || stockingModal.positionsWithOrderStateNew.length > 0  && stockingModal.positions.length > 0">
                    <hr>
                    restliche Positionen zum Einlagern:
                    <div class="stockingModalInfo">
                        <span v-for="position in filterPositionsForStocking(this.stockingModal.positions)" :key="position?.id">
                            Barcode: {{position ? position.barcode : null}} -- restliche Menge: {{position ? (position.quantity-getSumProcessedQuantity(position)): null}}<br/>
                        </span>
                    </div>
                    <hr>
                    <div v-if="stockingModal.errors.length > 0" class="stockingModalInfo" >
                        Folgende Fehler sind aufgetreten: <br/>
                        <span v-for="(error, index) in stockingModal.errors" :key="index">{{error}}<br/></span>
                    </div>            
                </div>
                <!-------------------When no conflict Multiple Positions------------------------->
                <div v-if="stockingModal.blockedPositions.length === 0 && stockingModal.positionsWithOrderStateNew.length === 0 && stockingModal.positions.length > 0">
                    Folgende Positionen zum Einlagern ausgewählt:
                    <div class="stockingModalInfo">
                        <span v-for="position in stockingModal.positions" :key="position?.id">
                            Barcode: {{position ? position.barcode : null}} -- restliche Menge: {{position ? (position.quantity-getSumProcessedQuantity(position)): null}}<br/>
                        </span>
                    </div>
                    <hr>
                    <div v-if="stockingModal.errors.length > 0" class="stockingModalInfo" >
                        Folgende Fehler sind aufgetreten: <br/>
                        <span v-for="(error, index) in stockingModal.errors" :key="index">{{error}}<br/></span>
                    </div>
                </div>
                 <!-------------------Footer Multiple Positions------------------------->
                <template #modal-footer="{cancel}" v-if="Array.isArray(stockingModal.positions)">
                    <b-button variant="secondary" @click="cancel()">Abbrechen</b-button>
                    <b-button variant="primary" 
                    type="button"
                    title="Es werden Alle Positionen eingelagert. Auch Positionen bei denen eine Bestellung mit dem Status 'Neu' vorliegt."
                    @click="stockPositions(filterBlockedPositionsForStocking(stockingModal.positions))">
                        Alle Einlagern
                    </b-button>
                    <b-button v-if="stockingModal.positionsWithOrderStateNew?.length > 0" 
                    variant="primary" type="button"
                    title="Es werden nur die restlichen Positionen eingelagert" 
                    @click="stockPositions(filterPositionsForStocking(stockingModal.positions))">
                        restliche Positionen einlagern
                    </b-button>
                </template>
                <!-------------------Footer Single Position------------------------->
                <template #modal-footer="{cancel, close}" v-else>
                    <b-button variant="secondary" @click="cancel()">Abbrechen</b-button>
                    <b-button variant="primary" type="button" @click="stockSinglePosition(stockingModal.position); close()">Einlagern</b-button>
                </template>                
        </b-modal>
        <b-modal>
            <template #modal-header>
                <h2 class="text-center"></h2>
            </template>            
                       
        </b-modal>
        <dn-create-claim-modal v-model="claimModal.show" :passedUnprocessedPositions="claimModal.positions" 
            :vendor="vendor" @dnpProcessingAdded="addProcessing" @claimsCreated="resetFilter()">
        </dn-create-claim-modal>
	    <modal-error-component v-model="modalError"></modal-error-component>
    </div>
</template>
<script>
import { useBoxIdStore } from '../../stores/BoxIdStore';
import { mapState } from 'pinia';
import QrcodeVue from 'qrcode.vue'
import CopyToClipboardComponent from "../util/CopyToClipboardComponent.vue";

export default {
	components: {
		QrcodeVue,
    CopyToClipboardComponent
	},
  data() {
    return {
      currentPage: 1,
      perPage: 25,
      amountOptions: [10, 25, 50],
      openOnly: true,
      processedOnly: false,
      filter: "",
      showCompleteAllModal: false,
      showQRCodeModal: false,
      qrCodeString: 'DN' + this.$route.params.deliveryNoteId,
      hasReturnImages: false,
      claimModal: {
        show: false,
        positions: [],
      },
      stockingModal: {
        title: "Direkte Einlagerung",
        show: false,
        busy: false,
        positions: [],
        position: {},
        errors: [],
        hasCustomerOrderStateNew: false,
        positionsWithOrderStateNew: [],
        isBlocked: false,
        blockedPositions: [],
      },
      users: [],
      markets: [],
      user: { id: null },
      vendor: null,
      deliveryNote: null,
      positions: [],
      fields: [
        { key: "_isSelected", label: "" },
        { key: "barcode", label: "Barcode" },
        { key: "deliverynote.number", label: "LS-Nummer" },
        { key: "reference", label: "Referenz" },
        {
          key: "deliverynote.date",
          label: "LS-Datum",
          sortable: true,
          formatter: function (s) {
            return s ? moment(s).format("DD.MM.YYYY") : "-";
          },
        },
        { key: "quantity", label: "Menge" },
        { key: "quantityProcessed", label: "verarb. Menge" },
        { key: "purchasePrice", label: "Bestellpreis" },
        { key: "orderState", label: "Status" },
        { key: "actions", label: "Aktionen" },
      ],
      modalError: {
        show: false,
        message: "unpopulated",
        error: "unpopulated",
        title: "unpopulated",
      },
      orderStates: {
        types: {
          "-1": "Offen",
          0: "Neu",
          1: "Erledigt",
          2: "Freigegeben",
          3: "Erstattung ausstehend",
          4: "Erstattet",
          5: "In Bearbeitung",
        },
        codes: {
          STATUS: -2,
          OPEN: -1,
          NEW: 0,
          DONE: 1,
          WAIT: 2,
          REFUND: 3,
          REFUND_OK: 4,
					IN_PROGRESS: 5,
        },
      },
    };
  },
	watch: {
		'$route.params': {
			handler() {
				axios.get(this.positionsFetchService).then((response) => {
					this.positions = response.data.map((position) => {
						position._isSelected = false;
						position._quantityToProcess = 1;
						return position;
					});
				});
			},
			immediate: true
		}
	},
  created() {
    // console.log(this.positionsFetchService)
    Promise.all([
      axios.get("/user/all"),
      axios.get("/user/self"),
      axios.get(
        "/deliverynote/" + this.$route.params.deliveryNoteId + "/withVendor",
      ),
      axios.get(this.positionsFetchService),
      axios.get("/vendor/" + this.$route.params.vendorId + "/fetch"),
			axios.get(`/mds/market`),
			axios.get("/deliverynote/" + this.$route.params.deliveryNoteId + "/returnimages/exists"),
    ]).then((responses) => {
      this.users = responses[0].data;
      this.user = responses[1].data;
      this.deliveryNote = responses[2].data;
      this.positions = responses[3].data.map((position) => {
        position._isSelected = false;
        position._quantityToProcess = 1;
        return position;
      });
      this.vendor = responses[4].data;
      this.markets = responses[5].data;
      this.hasReturnImages = responses[6].data;
      Vue.nextTick(() => {
        if (this.$refs.search !== undefined) this.$refs.search.focus();
      });
    });
    if (this.$route.params.deliveryNoteId == -3) {
      this.openOnly = false;
    } else {
      this.openOnly = true;
    }
  },
  computed: {
    articleCount() {
      return this.positions
        .map((position) => position.quantity)
        .reduce((acc, cur) => acc + cur, 0);
    },
    openPositions() {
      return this.positions.filter((position) => !this.isProcessed(position));
    },
    openArticleCount() {
      return this.openPositions
        .map((position) => this.getUnprocessedQuantity(position))
        .reduce((acc, cur) => acc + cur, 0);
    },
    filteredPositions() {
      return this.positions.filter(
        (position) =>
          (position.barcode.includes(this.filter.trim()) ||
            (position.material &&
              (position.material.ean.includes(this.filter.trim()) ||
                position.material.eans.find((addEan) =>
                  addEan.ean.includes(this.filter.trim()),
                ) !== undefined))) &&
          (!this.openOnly || !this.isProcessed(position)) &&
          (!this.processedOnly || this.isProcessed(position)),
      );
    },
    selectedPositions() {
      return this.filteredPositions.filter((position) => position._isSelected);
    },
    positionsFetchService() {
      if (this.$route.params.vendorId > 0) {
        if (this.$route.params.deliveryNoteId == -1) {
          return `/deliverynote/positions/${this.$route.params.vendorId}/fetch_all_by_vendor`;
        } else if (this.$route.params.deliveryNoteId == -2) {
          return `/deliverynote/positions/${this.$route.params.vendorId}/fetch_approved_by_vendor`;
        } else if (this.$route.params.deliveryNoteId == -3) {
          return `/deliverynote/positions/${this.$route.params.vendorId}/fetch_recent_positions`;
        } else {
          return `/deliverynote/positions/${this.$route.params.deliveryNoteId}/fetch`;
        }
      }
    },
    filteredfields() {
      if (this.$route.params.deliveryNoteId == -3) {
        return this.fields;
      } else {
        return this.fields.filter((field) => field.key != "deliverynote.date");
      }
    },
    allSelected() {
      return this.filteredPositions.length == this.selectedPositions.length;
    },
		...mapState(useBoxIdStore, ['boxIdString']),
  },
  methods: {
    processCheckAllSelections() {
      let inv = !this.allSelected;
      this.filteredPositions.forEach((p) => (p._isSelected = inv));
    },
    uncheckAllPositions() {
      this.positions = this.positions.map((position) => {
        position._isSelected = false;
        return position;
      });
    },
    getSumProcessedQuantity(item) {
      return item?.deliverynotepositionprocesss
        ?.map((process) => process.quantityProcessed)
        .reduce((acc, cur) => acc + cur, 0);
    },
    getUnprocessedQuantity(item) {
      return (
        item.quantity -
        item.deliverynotepositionprocesss
          .map((process) => process.quantityProcessed)
          .reduce((acc, cur) => acc + cur, 0)
      );
    },
    isProcessed(item) {
      return this.getSumProcessedQuantity(item) == item.quantity;
    },
    rowClassSelector(item, type) {
      if (!item || type !== "row") return;
      if (this.isProcessed(item)) return "strike";
    },
    //world wide blocked Positions and Positions where a CustomerOrder with OrderState New was found get filtered
    filterPositionsForStocking(positions) {
      let filterdPosition = positions.filter(
        (position) => !this.stockingModal.blockedPositions.includes(position),
      );
      filterdPosition = filterdPosition.filter(
        (position) =>
          !this.stockingModal.positionsWithOrderStateNew.includes(position),
      );
      return filterdPosition;
    },
    //only world wide blocked Positions get filtered
    filterBlockedPositionsForStocking(positions) {
      console.log(positions);
      let filterdPosition = positions.filter(
        (position) => !this.stockingModal.blockedPositions.includes(position),
      );
      console.log(filterdPosition);
      return filterdPosition;
    },
    labelOrderState(orderState) {
      switch (orderState) {
        case this.orderStates.codes.OPEN:
          return "⚪ Offen";
        case this.orderStates.codes.NEW:
          return "⚫ Neu";
        case this.orderStates.codes.DONE:
          return "🟢 Erledigt";
        case this.orderStates.codes.WAIT:
          return "🟡 Freigegeben";
        case this.orderStates.codes.REFUND:
          return `${this.blink ? "🔴" : "⚪"} Erstattet`;
        case this.orderStates.codes.REFUND_OK:
          return "🔴 Erstattet";
				case this.orderStates.codes.IN_PROGRESS:
					return "🔵 In Bearbeitung";
        default:
          return "???";
      }
    },
    switchPackageArrived() {
      axios
        .get(
          `/deliverynote/package_${this.deliveryNote.packageArrived ? "not_" : ""}arrived/${this.deliveryNote.id}`,
        )
        .then((response) => {
          this.deliveryNote.packageArrived = !this.deliveryNote.packageArrived;
          this.deliveryNote.deliverynotecomments.push(response.data); //Insert the returned Comment
        })
        .catch((error) => {
          console.error(error);
        });
    },
    showClaimModalFor(positionsToClaim) {
      this.claimModal.positions = positionsToClaim;
      this.claimModal.show = true;
    },
    resetStockingModal() {
      this.stockingModal.busy = false;
      this.stockingModal.positions = [];
      this.stockingModal.position = {};
      this.stockingModal.errors = [];
      this.stockingModal.hasCustomerOrderStateNew = false;
      this.stockingModal.positionsWithOrderStateNew = [];
      this.stockingModal.isBlocked = false;
      this.stockingModal.blockedPositions = [];
    },
    stockPositions(positionsToStock) {
			if(this.boxIdString === null || this.boxIdString.trim() === "") {
				this.modalError = {
					show: true,
					message: "Bitte geben Sie eine Kisten-ID an. In der Navigationsleiste neben dem Namen können Sie die Kisten-ID setzen.",
					error: "",
					title: "Kisten-ID fehlt",
				};
				return;
			}
      this.stockingModal.errors = [];
      let promises = [];
      positionsToStock.forEach((p) => {
        let request = {};
        if (p.quantity - this.getSumProcessedQuantity(p) <= 0) {
          return;
        }
        request.quantity = p.quantity - this.getSumProcessedQuantity(p);
        request.deliveryNotePositionId = p.id;
        request.boxId = this.boxIdString;

        promises.push(
          axios
            .post("/dnstocking", request)
            .then((res) => {
              //    console.log(res);
              this.addProcessing(res.data);
            })
            .catch((err) => {
              console.log(err);
              this.stockingModal.errors.push(err + " - Barcode: " + p.barcode);
            }),
        );
      });
      Promise.all(promises)
        .then((res) => {
          this.stockingModal.show = false;
          // this.resetStockingModal()
        })
        .catch((err) => {
          this.stockingModal.show = false;
          this.modalError = {
            show: true,
            message: "Konnte nicht eingelagert werden.",
            error: err,
            title: "Direkteinlagerung",
          };
        });
    },
    stockSinglePosition(positionToStock) {
      //_quantityToProcess
			if(this.boxIdString === null || this.boxIdString.trim() === "") {
				this.modalError = {
					show: true,
					message: "Bitte geben Sie eine Kisten-ID an. In der Navigationsleiste neben dem Namen können Sie die Kisten-ID setzen.",
					error: "",
					title: "Kisten-ID fehlt",
				};
				return;
			}
      if (positionToStock._quantityToProcess == "") return;
      let request = {
        quantity: positionToStock._quantityToProcess,
        deliveryNotePositionId: positionToStock.id,
        boxId: this.boxIdString,
      };
      return axios
        .post("/dnstocking", request)
        .then((res) => {
          // console.log(res);
          this.addProcessing(res.data);
        })
        .catch((err) => {
          console.log(err);
          this.modalError = {
            show: true,
            message: "Konnte nicht eingelagert werden.",
            error: err,
            title: "Stock single Position",
          };
        });
    },

    checkForStates(positions) {
      //checks for the materialIds if there is a customerOrder with the orderstate 0 (new) - for multiple positions
      //also checks if a positions is blocked everywhere
      this.stockingModal.positions = positions;
      //positions are either array (mulit selection) or object (when action clicked)
      if (Array.isArray(positions)) {
        let promises = [];
        this.stockingModal.positions.forEach((position) => {
          promises.push(
            axios
              .get(
                "/material/has_orderstate_new/" + // /material/has_orderstate_new/
                  position.materialId,
              )
              .then((res) => {
                if (res.data == true) {
                  this.stockingModal.positionsWithOrderStateNew.push(position);
                  this.stockingModal.hasCustomerOrderStateNew = true;
                }
              }),
          );
          this.stockingModal.isBlocked = false;
          if (position.materialId) {
            promises.push(
              axios
                .get("/deliverynote/check_for_blocker/" + position.materialId)
                .then((res) => {
                  // console.log(res.data);
                  this.stockingModal.isBlocked = this.markets.reduce(
                    (otherMarkets, market) => {
                      let blockerComputed = res.data.find(
                        (b) => b.marketId === market.id,
                      );
                      if (!blockerComputed) return false;
                      return otherMarkets && blockerComputed.blackOrWhite;
                    },
                    true,
                  );
                  if (this.stockingModal.isBlocked) {
                    this.stockingModal.blockedPositions.push(position);
                  }
                  // console.log(this.stockingModal.isBlocked);
                }),
            );
          } else {
            this.stockingModal.errors.push(
              "No Material_Id found for Barcode " +
                position.barcode +
                " - Referenz: " +
                position.reference,
            );
          }
        });
        Promise.all(promises).then((res) => {
          this.stockingModal.busy = false;
          this.stockingModal.show = true;
        });
        // for single positon - check for materialId if there is a customerOrder with the "new" orderstate or blocked world
      } else {
        this.stockingModal.position = positions;
        let promises = [];
        promises.push(
          axios
            .get(
              "/material/has_orderstate_new/" +
                this.stockingModal.position.materialId,
            )
            .then((res) => {
              if (res.data == true) {
                this.stockingModal.hasCustomerOrderStateNew = true;
                this.stockingModal.positionsWithOrderStateNew.push(
                  this.stockingModal.position,
                );
              }
            })
            .catch((err) => console.log(err)),
        );
        if (this.stockingModal.position.materialId) {
          promises.push(
            axios
              .get(
                "/deliverynote/check_for_blocker/" +
                  this.stockingModal.position.materialId,
              )
              .then((res) => {
                // console.log(res.data);
                this.stockingModal.isBlocked = this.markets.reduce(
                  (otherMarkets, market) => {
                    let blockerComputed = res.data.find(
                      (b) => b.marketId === market.id,
                    );
                    if (!blockerComputed) return false;
                    return otherMarkets && blockerComputed.blackOrWhite;
                  },
                  true,
                );
                // console.log(this.stockingModal.isBlocked);
              }),
          );
        } else {
          this.modalError = {
            show: true,
            message:
              "Für diese Position (Barcode: " +
              this.stockingModal.position.barcode +
              " ) wurde keine Material_id gefunden",
            error: "",
            title: "Missing Material_id",
          };
        }
        Promise.all(promises).then((res) => {
          //if co found return warning
          if (this.stockingModal.hasCustomerOrderStateNew) {
            this.stockingModal.show = true;
          } else if (this.stockingModal.isBlocked) {
            this.modalError = {
              show: true,
              message: "Diese Position ist weltweit blockiert",
              error: "",
              title: "Blocked Position",
            };
            this.resetStockingModal();
          } else {
            this.stockSinglePosition(this.stockingModal.position);
            this.resetStockingModal();
          }
        });
      }
    },
    setProcessingReasonForSelection() {
      this.selectedPositions.forEach((p) => this.setProcessingReason(p));
    },
    setProcessingReasonQuantity(deliveryNotePosition) {
      if (deliveryNotePosition._quantityToProcess == "") return;
      axios
        .get(
          `/deliverynote/processingreason/gui/${deliveryNotePosition.id}/quantity/${deliveryNotePosition._quantityToProcess}`,
        )
        .then((response) => {
          if (response.status >= 200 && response.status <= 226) {
            for (let p of this.positions) {
              if (p.id == deliveryNotePosition.id) {
                p.deliverynotepositionprocesss.push(response.data);
                break;
              }
            }
            this.uncheckAllPositions();
            deliveryNotePosition._quantityToProcess = 1;
            if (this.openPositions.length == 0) {
              this.$router.push("/dn/v2/vendor/" + this.$route.params.vendorId);
            } else {
              this.resetFilter();
            }
          } else {
            let error = "status: " + response.status + "\n";
            error += "response: \n" + JSON.stringify(response, null, 2);

            this.modalError = {
              show: true,
              message: "Verarbeitungsgrund konnte nicht gesetzt werden.",
              error: error,
              title: "Set Processing Reason",
            };
          }
        })
        .catch((err) => {
          this.modalError = {
            show: true,
            message: "Verarbeitungsgrund konnte nicht gesetzt werden.",
            error: err,
            title: "Set Processing Reason",
          };
        });
    },
    setProcessingReason(deliveryNotePosition) {
      axios
        .get("/deliverynote/processingreason/gui/" + deliveryNotePosition.id)
        .then((response) => {
          if (response.status >= 200 && response.status <= 226) {
            console.log(response.data);
            for (let p of this.positions) {
              if (p.id == deliveryNotePosition.id) {
                p.deliverynotepositionprocesss.push(response.data);
                break;
              }
            }
            this.uncheckAllPositions();
            if (this.openPositions.length == 0) {
              this.$router.push("/dn/v2/vendor/" + this.$route.params.vendorId);
            } else {
              this.resetFilter();
            }
          } else {
            console.log(response);
            let error = "status: " + response.status + "\n";
            error += "response: \n" + JSON.stringify(response, null, 2);

            this.modalError = {
              show: true,
              message: "Verarbeitungsgrund konnte nicht gesetzt werden.",
              error: error,
              title: "Set Processing Reason",
            };
          }
        })
        .catch((err) => {
          console.log(err);
          this.modalError = {
            show: true,
            message: "Verarbeitungsgrund konnte nicht gesetzt werden.",
            error: err,
            title: "Set Processing Reason",
          };
        });
    },
    addProcessing(process) {
      for (let p of this.positions) {
        if (p.id == process.deliveryNotePositionId) {
          p.deliverynotepositionprocesss.push(process);
          break;
        }
      }
      if (!this.claimModal.show) {
        this.resetFilter();
        this.uncheckAllPositions();
      }
    },
    resetFilter() {
      this.filter = "";
      this.$refs.search.focus();
    },
    revertProcessedPostion(position) {
      if (
        this.getSumProcessedQuantity(position) < position._quantityToProcess
      ) {
        this.modalError = {
          show: true,
          message:
            "Die ausgewählte Menge ist größer als die schon verarbeitete Menge.",
          error:
            "ausgewählte Menge: " +
            position._quantityToProcess +
            " - verarbeitete Menge: " +
            this.getSumProcessedQuantity(position),
          title: "revertProcessedPosition",
        };
      }
      //Changing the sign from positiv to negativ
      position._quantityToProcess = position._quantityToProcess * -1;
      this.setProcessingReasonQuantity(position);
    },
    finalizeDeliveryNote() {
      axios
        .post("/deliverynote/finalize/" + this.$route.params.deliveryNoteId)
        .then((response) => {
          if (response.status >= 200 && response.status <= 226) {
            this.$router.push("/dn/v2/vendor/" + this.$route.params.vendorId);
          } else {
            this.modalError = {
              show: true,
              message: "Lieferschein konnte nicht abgeschlossen werden.",
              error: JSON.stringify(response, null, 2),
              title: "Finalize Delivery Note",
            };
          }
        })
        .catch((err) => {
          this.modalError = {
            show: true,
            message: "Lieferschein konnte nicht abgeschlossen werden.",
            error: err,
            title: "Finalize Delivery Note",
          };
        });
    },
    exportToXSLX(_positions) {
      let currentDate = moment().format("DD.MM.YYYY");
      let mappedPositions = _positions.map((position) => {
        return {
          Barcode: position.barcode,
          "LS-Nummer": position.deliverynote.number,
          Referenz: position.reference,
          Menge: position.quantity,
          "verarb. Menge": this.getSumProcessedQuantity(position),
          Bestellpreis: position.purchasePrice,
          Status: position.orderlog
            ? this.labelOrderState(
                position.orderlog.customerorder.orderState,
              ).slice(2)
            : "Kein Orderlog",
        };
      });

      Vue.nextTick().then(() => {
        const ws = XLSX.utils.json_to_sheet(mappedPositions, {
          sheet: this.vendor.name,
        });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "");
        XLSX.writeFile(
          wb,
          this.vendor.name + "-Lieferschein-" + currentDate + ".xlsx",
        );
      });
    },
		downloadReturnImages() {
			axios.get(`/deliverynote/${this.deliveryNote.id}/returnimages/download`)
					.then((response) => {
						console.log(response);
						const images = response.data;
						images.forEach((b64Data, index) => {
							// Convert raw base64 to a Blob
							const byteCharacters = atob(b64Data);
							const byteNumbers = new Array(byteCharacters.length);

							for (let i = 0; i < byteCharacters.length; i++) {
								byteNumbers[i] = byteCharacters.charCodeAt(i);
							}

							const byteArray = new Uint8Array(byteNumbers);
							const blob = new Blob([byteArray], { type: 'image/jpeg' });

							// Trigger download
							const url = window.URL.createObjectURL(blob);
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', `LF-Return_${index + 1}_${this.deliveryNote.id}.jpg`);

							document.body.appendChild(link);
							link.click();

							// Cleanup
							document.body.removeChild(link);
							window.URL.revokeObjectURL(url);
						});
					})
					.catch((error) => {
						console.error('Fehler beim Herunterladen der Rücksendebilder:', error);
					});
		},
  },
};
</script>
<style scoped>
.mikasmallz td {
  padding-top: 0;
  padding-bottom: 0;
}

.clickable {
  cursor: pointer;
  color: black;
}
.smallinput {
  height: 20px;
  width: 25px;
}
.stockingModalInfo {
  max-height: 150px;
  overflow: auto;
}
</style>
<style>
.strike td {
  text-decoration: line-through;
}
</style>